import { render, staticRenderFns } from "./AppButtonApproval.vue?vue&type=template&id=a213d442&scoped=true&"
import script from "./AppButtonApproval.vue?vue&type=script&lang=js&"
export * from "./AppButtonApproval.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonApproval.vue?vue&type=style&index=0&id=a213d442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a213d442",
  null
  
)

export default component.exports